import { lazy } from 'react';
import InsightsIcon from '@mui/icons-material/Insights';
import HistoryIcon from '@mui/icons-material/History';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PoolIcon from '@mui/icons-material/Pool';
import PlaceIcon from '@mui/icons-material/Place';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight'; // Added
import { getWorkoutSessionById } from '../../services/workoutSessionApi';
import { getWorkoutPlanById } from '../../services/workoutPlanApi';
import { getExerciseDefinitionById } from '../../services/exerciseDefinitionApi';
import { getLocationFeatureById } from '../../services/locationFeatureApi';
import { getMyLocations } from '../../services/locationApi';
import { getBioLogById } from '../../services/bioLogsApi'; // Added

const CalendarsDashboardViewer = lazy(() => import('@platform/core/src/components/resources/viewer/viewers/CalendarsDashboardViewer'));
const CalendarResourceViewer = lazy(() => import('@platform/core/src/components/resources/viewer/viewers/CalendarResourceViewer'));
const WorkoutSessionResourceViewer = lazy(() => import('../../components/workouts/WorkoutSessionResourceViewer'));
const WorkoutPlanResourceViewer = lazy(() => import('../../components/workouts/WorkoutPlanResourceViewer'));
const ActivityResourceViewer = lazy(() => import('../../components/activities/ActivityResourceViewer'));
const LocationResourceViewer = lazy(() => import('../../components/location/LocationResourceViewer'));
const EquipmentResourceViewer = lazy(() => import('../../components/equipment/EquipmentResourceViewer'));
const StatsDashboardViewer = lazy(() => import('../../components/stats/StatsDashboardViewer'));
const BioLogResourceViewer = lazy(() => import('../../components/bio-logs/BioLogResourceViewer')); // Added

export const contentTypesConfig = {
  date: {
    getTitle: (resource) => resource.title || 'Untitled Event',
  },
  calendars_dashboard: {
    viewer: CalendarsDashboardViewer,
    getTitle: () => 'My Calendar',
  },
  calendar: {
    viewer: CalendarResourceViewer,
    getTitle: (resource) => resource.title || 'Calendar',
  },
  stats_dashboard: {
    viewer: StatsDashboardViewer,
    icon: { component: InsightsIcon, props: { color: 'primary' } },
    getTitle: () => 'Analytics Dashboard',
  },
  workout_session: {
    viewer: WorkoutSessionResourceViewer,
    icon: { component: HistoryIcon, props: { color: 'primary' } },
    getTitle: (resource) => resource.name || `Session on ${new Date(resource.created_at).toLocaleDateString()}`,
    fetcher: getWorkoutSessionById,
    handler: {
      includeResourceTagInChat: false,
    },
  },
  workout_plan: {
    viewer: WorkoutPlanResourceViewer,
    icon: { component: AssignmentIcon, props: { color: 'primary' } },
    getTitle: (resource) => resource.name || 'Workout Plan',
    fetcher: getWorkoutPlanById,
    handler: {
      includeResourceTagInChat: false,
    },
  },
  exercise_definition: {
    viewer: ActivityResourceViewer,
    icon: { component: PoolIcon, props: { color: 'primary' } },
    getTitle: (resource) => resource.name || 'Exercise',
    fetcher: getExerciseDefinitionById,
  },
  location: {
    viewer: LocationResourceViewer,
    icon: { component: PlaceIcon, props: { color: 'primary' } },
    getTitle: (resource) => resource.name || 'Location',
    fetcher: async (id) => {
        const locs = await getMyLocations();
        return locs.find(l => l.id === id);
    }
  },
  equipment: {
    viewer: EquipmentResourceViewer,
    icon: { component: FitnessCenterIcon, props: { color: 'primary' } },
    getTitle: (resource) => resource.name || 'Equipment',
    fetcher: getLocationFeatureById,
  },
  location_feature: {
    viewer: EquipmentResourceViewer,
    icon: { component: FitnessCenterIcon, props: { color: 'primary' } },
    getTitle: (resource) => resource.name || 'Equipment',
    fetcher: getLocationFeatureById,
  },
  bio_log: {
    viewer: BioLogResourceViewer,
    icon: { component: MonitorWeightIcon, props: { color: 'primary' } },
    getTitle: (resource) => `${resource.log_type || 'Bio Log'} Entry`,
    fetcher: getBioLogById,
  },
};